import React, { FunctionComponent, memo, useEffect, useState } from "react";
import { useStockPriceFeed } from "../../../../hooks/useStockPriceFeed";
import "./StockTicker.scss";

const StockTicker: FunctionComponent<any> = () => {
  const stockPriceFeed = useStockPriceFeed();

  const [display, setDisplay] = useState(false);
  useEffect(() => {
    if(stockPriceFeed && stockPriceFeed.NYSE && stockPriceFeed.NYSE.value && stockPriceFeed.NYSE.value.indexOf('undefined') == -1) {
      setDisplay(true);
    }
    else {
      setDisplay(false);
    }
  }, [stockPriceFeed])

  return (
    <div className={`StockTicker ${!display ? 'StockTicker__hide' : ''}`}>
      <h6>CNH</h6>
      <div>NYSE</div>
      <p className={stockPriceFeed.NYSE.uptrend ? "uptrend" : "downtrend"}>
        {stockPriceFeed.NYSE.value}
      </p>
      <div>*</div>
    </div>
  );
};

export default memo(StockTicker);
